import { Avatar, Box, Button, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

import Camera from 'assets/icons/camera.svg';
import { titleTextColor } from 'assets/styles/_palette';

export const ChangeImage = styled(Box)({
	...flexMixin({ direction: 'column' }),
});

export const LoaderContainer = styled(Box)({
	...flexMixin({}),
	width: '106px',
	height: '106px',
});

export const Inputs = styled(Box)({
	...flexMixin({ justify: 'flex-start', gap: 24, direction: 'column' }),
	flexWrap: 'wrap',
	width: '100%',
});

export const ChangePassword = styled(Box)({
	...flexMixin({ justify: 'space-between' }),
	width: '100%',
	'& button': {
		width: '275px',
		padding: '10px 16px',
		borderRadius: '8px',
		border: '1px solid #4786FF',
		fontSize: '16px',
		fontWeight: '700',
		lineHeight: '157%',
		letterSpacing: '0.1px',
		textTransform: 'none',
		color: '#4786FF',
	},
});

export const ChangePasswordInfo = styled(Box)({
	...flexMixin({ direction: 'column', align: 'flex-start', gap: 4 }),
	'& h4': {
		fontSize: '16px',
		fontWeight: 700,
		lineHeight: '157%',
		letterSpacing: '0.1px',
		color: titleTextColor,
	},
});

export const DeleteButton = styled(Button)({
	...flexMixin({ gap: 8 }),
	width: '100%',
	borderRadius: '8px',
	fontSize: '16px',
	fontWeight: '700',
	lineHeight: '157%',
	letterSpacing: '0.1px',
	textTransform: 'none',
	color: '#FB0B24',
	marginTop: 'auto',
	padding: '10px 16px',
	'& svg path': {
		fill: '#FB0B24',
	},
});

export const UploadAvatar = styled(Box)({
	...flexMixin({}),
	width: '106px',
	height: '106px',
	borderRadius: '50%',
	border: '1px dashed rgba(26, 36, 47, 0.20)',
	background: '#FAFAFA',
	cursor: 'pointer',
	'& svg': {
		height: '50px',
		width: '50px',
		'& path': {
			stroke: '#4786FF',
		},
	},
});

export const UserAvatar = styled(Avatar)({
	position: 'relative',
	width: '106px',
	height: '106px',
	borderRadius: '50%',

	'&:hover::after': {
		opacity: 1,
	},
	'&::after': {
		content: '""',
		opacity: 0,
		position: 'absolute',
		background: `url('${Camera}') center / cover  no-repeat, rgba(0, 0, 0, 0.5)`,
		backgroundSize: '50px 50px',
		width: '106px',
		height: '106px',
		borderRadius: '50%',
		transition: '0.4s',
		cursor: 'pointer',
	},
});
